module.exports = __webpack_public_path__ + "static/media/webstorm.304a94d2.png";